<template>
    <div v-if="!asset.loaded" class="placeholder-container">
        <span class="placeholder-preview"></span>
        <span class="placeholder-label"></span>
    </div>

    <div v-else class="compare-view-item-container" :data-index="asset.id">
        <img :src="thumbnail" @load="revokeObjectURL(thumbnail)" @dblclick="openAsset(asset)" :data-index="asset.id" />
        <div class="label-container">
            <span class="name">{{
                    asset.type == 'media' ? stripTimestamp(`${asset.name}.${asset.fileType}`) : stripTimestampAndExtension(asset.name)
                }}</span>
        </div>

        <v-menu offset-y :content-class="'file-options-container'">
            <template v-slot:activator="{ on }">
                <i class="material-icons" style="cursor: pointer" v-on="on">more_vert</i>
            </template>
            <v-list>
                <v-list-item
                        @click="downloadLUT(asset)"
                        :disabled="!canExportLUT"
                >
                    <i class="material-icons">save_alt</i>
                    <v-list-item-title>Download a LUT</v-list-item-title>
                </v-list-item>
                <v-list-item @click="removeCandidate(asset)"
                >
                    <v-icon class="material-icons">mdi-delete</v-icon>
                    <v-list-item-title>Remove from My Selection</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import CanMixin from '@/mixins/CanMixin';
import FilenameMixin from '@/mixins/Filename';
import { mapActions, mapGetters, mapState } from 'vuex';
import { stripExtension } from '@/assets/js/Utilities';
import { candidatesStore } from '@/services/indexedDB.service';

export default {
    mixins: [CanMixin, FilenameMixin],

    data() {
        return {
            thumbnail: null
        };
    },

    computed: {
        ...mapState('Projects', ['tags']),
        ...mapGetters('User', ['isGuest']),
    },

    props: {
        asset: Object,
    },

    created() {
        if (this.asset.loaded) this.thumbnail = URL.createObjectURL(this.asset.image);
    },

    methods: {
        ...mapActions('Helpers', ['revokeObjectURL']),

        async openAsset(candidate) {
            UI.hideModal(UI.modals.compareView.el, true);
            // showing the progress before thread is blocked by applying candidate
            await new Promise(resolve => {
                this.$store.dispatch('Loader/showProgressBar', 'indeterminate');

                setTimeout(() => {
                    resolve();
                }, 50);
            });

            this.$store.dispatch('Projects/setActiveCandidate', candidate.id);

            if (candidate.rawDevelopment && loader.typeOfActiveMedia('raw')) await vm.rawDevelopment.applyData(candidate.rawDevelopment);
            await window.lutify.applyCompare(candidate.blocks, 'waitToLoad', false);

            this.$store.dispatch('Loader/showProgressBar', false);

            window.UI.removeFileLoadingSpinner(candidate.id);
            // UI.removeCandidateLoadingSpinner();
            window.UI.hideImageLoader();
            window.UI.toggleImageTools();
        },

        async downloadLUT(selectedFile) {
            if (lutify.isCurrentPlanFree()) {
                UI.showSecondLevelModal(UI.modals.notAvailableInFree.el);
                return;
            }

            let assetsStoreData = [];
            for await (const file of [selectedFile]) {
                if (file.type == 'image' || file.type == 'media') {
                    const image = await window.lutify.fetchImage(file);
                    await window.lutify.storeLastState();
                    const { blocks } = await window.lutify.fetchLastState(file.id);
                    image.blocks = blocks;
                    image.nicename = stripExtension(image.name);
                    assetsStoreData.push(image);
                } else if (file.type == 'candidate') assetsStoreData.push(await window.lutify.fetchCandidate(file));
                else if (file.type == 'match') assetsStoreData.push(await window.lutify.fetchMatch(file));
            }

            await this.$store.dispatch('Projects/setAction', {
                type: this.asset.type,
                action: 'export-lut-from-asset',
                data: assetsStoreData,
            });

            UI.showSecondLevelModal(UI.modals.exportLut.el);
        },

        async removeCandidate(candidate) {
            await candidatesStore.removeItem(candidate.id);
            this.$store.commit('UI/REMOVE_CANDIDATE', candidate.id);
            this.$store.commit('UI/REMOVE_ASSET_FROM_COMPARE_VIEW', candidate.id);
        },

    }
};
</script>

<style lang="scss" scoped>
.placeholder-container {
	.placeholder-preview {
		height: auto;
		aspect-ratio: 16/9;
	}

	.placeholder-label {
		height: 20px;
	}
}

.compare-view-item-container {
	display: grid;
	grid-template-columns: 1fr auto auto;
	grid-template-rows: 1fr auto;
	grid-row-gap: 5px;
	grid-column-gap: 4px;
	align-items: center;
	padding-bottom: 2px;
	border: 2px solid transparent;

	&:hover {
		border: 2px solid var(--primary);
		border-radius: 8px;
	}

	img {
		grid-column: 1 / 4;
		border-radius: 8px;

	}

	.label-container {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.2;
		padding-left: 5px;
	}
}
</style>
